(function() {
    'use strict';
    angular
        .module('backApp')
        .factory('ThemeClassify', ThemeClassify);

    ThemeClassify.$inject = ['$resource'];

    function ThemeClassify ($resource) {
        var resourceUrl =  'manager/' + 'api/theme-classify/:path/:id';
        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "del":{
                method:"DELETE"
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            "get":{
                method:"GET"
            },
            "save":{
                method:"PUT"
            }
        });
    }
})();
